import {
	TChangeComboGroupPositionSelectedItem,
	TTypeOfChangeComboGroupPositionModalWindow,
} from './changeComboGroupPositionContext';
import { IComboGroupPositionItem, IUpdateComboGroupPositions } from 'types';

export enum ChangeComboGroupPositionActionTypes {
	SET_ID_CUSTOMER = 'SET_ID_CUSTOMER',
	SET_ID_RESTAURANT = 'SET_ID_RESTAURANT',
	SET_ID_DISH = 'SET_ID_DISH',
	RESET_SELECTED_CONTROLS = 'RESET_SELECTED_CONTROLS',
	SET_POSITIONS_DATA = 'SET_POSITIONS_DATA',
	REORDER_ITEMS = 'REORDER_ITEMS',
	SET_DATA_FOR_SUBMIT = 'SET_DATA_FOR_SUBMIT',
	CHANGE_TYPE_OF_MODAL_WINDOW = 'CHANGE_TYPE_OF_MODAL_WINDOW',
}

interface ISetIDCustomer {
	type: ChangeComboGroupPositionActionTypes.SET_ID_CUSTOMER;
	payload: {
		IDSelectedCustomer: TChangeComboGroupPositionSelectedItem;
	};
}

interface ISetIDRestaurant {
	type: ChangeComboGroupPositionActionTypes.SET_ID_RESTAURANT;
	payload: {
		IDSelectedRestaurant: TChangeComboGroupPositionSelectedItem;
	};
}

interface ISetIDDish {
	type: ChangeComboGroupPositionActionTypes.SET_ID_DISH;
	payload: {
		IDSelectedDish: TChangeComboGroupPositionSelectedItem;
	};
}

interface IResetSelectedControls {
	type: ChangeComboGroupPositionActionTypes.RESET_SELECTED_CONTROLS;
}

interface ISetPositionsData {
	type: ChangeComboGroupPositionActionTypes.SET_POSITIONS_DATA;
	payload: {
		positionsData: IComboGroupPositionItem[];
	};
}

interface IReorderItems {
	type: ChangeComboGroupPositionActionTypes.REORDER_ITEMS;
	payload: {
		newOrder: IComboGroupPositionItem[];
	};
}

interface ISetDataForSubmit {
	type: ChangeComboGroupPositionActionTypes.SET_DATA_FOR_SUBMIT;
	payload: {
		dataForSubmit: IUpdateComboGroupPositions | null;
	};
}

interface IChangeTypeOfModalWindow {
	type: ChangeComboGroupPositionActionTypes.CHANGE_TYPE_OF_MODAL_WINDOW;
	payload: {
		typeOfModalWindow: TTypeOfChangeComboGroupPositionModalWindow;
	};
}

export type TChangeComboGroupPositionActions =
	| ISetIDCustomer
	| ISetIDRestaurant
	| ISetIDDish
	| IResetSelectedControls
	| ISetPositionsData
	| IReorderItems
	| ISetDataForSubmit
	| IChangeTypeOfModalWindow;
